import { useEffect, useRef } from "react";
import "./ShortsVideo.css";

function ShortsVideo({ video, active, onVisible }) {
  const iframeRef = useRef(null);
  const containerRef = useRef(null);

  // 🔹 Observe visibility
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          onVisible();
        }
      },
      { threshold: 0.8 }
    );

    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, [onVisible]);

  // 🔹 Play / Pause based on active
  useEffect(() => {
    if (!iframeRef.current) return;

    iframeRef.current.contentWindow?.postMessage(
      JSON.stringify({
        event: "command",
        func: active ? "playVideo" : "pauseVideo"
      }),
      "*"
    );
  }, [active]);

  if (!video?.videoId) return null;

  return (
    <div ref={containerRef} className="short">
      <iframe
        ref={iframeRef}
        src={`https://www.youtube.com/embed/${video.videoId}?enablejsapi=1&playsinline=1&controls=0&rel=0`}
        title={video.title}
        allow="autoplay; encrypted-media"
        allowFullScreen
      />

      <div className="meta">
        <h4>{video.title}</h4>
        <span>{video.channel}</span>
      </div>
    </div>
  );
}

export default ShortsVideo;
